import React, { useEffect, useMemo, useRef } from 'react';
import PreviewForm from '../../components/forms/preview';
import useDsBreach from './form/hooks/useDsBreach';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';

export const sendHeightToIframeForms = (current) => {
    const sendHeight = () => {
        const scrollHeight = current?.clientHeight + 100;
        const height = scrollHeight;
        window.parent.postMessage(
            { type: 'data_breach_form_iframe_height', height },
            '*'
        );
    };
    window.addEventListener('resize', sendHeight);
    return sendHeight();
};

export default function View() {
    const { id } = useParams();
    const ref = useRef();

    const { dsBreachDetail, getDataBreachFormPublichById, loading } =
        useDsBreach({ isPreview: true });

    useEffect(() => {
        getDataBreachFormPublichById(id).then((res) => {
            if (res) sendHeightToIframeForms(ref?.current);
        });
    }, [getDataBreachFormPublichById, id]);

    const style = dsBreachDetail?.style || {};
    const backgroundColor = style?.backgroundColor || '#EDEEF9';
    let jsonData;
    if (dsBreachDetail?.jsonData) {
        jsonData = JSON.parse(dsBreachDetail.jsonData);
    }

    useEffect(() => {
        let app = document.getElementById('app');
        document.body.style.backgroundColor = backgroundColor;
        app.style.overflow = 'auto';
        return () => {
            document.body.style.backgroundColor = '';
            app.style.overflow = '';
        };
    }, [backgroundColor]);

    const refId = useMemo(() => {
        // decode refId from dsBreachDetail?.refId base64
        const refId = dsBreachDetail?.refId;
        if (refId) {
            const decodedRefId = atob(refId);
            return decodedRefId;
        }
    }, [dsBreachDetail?.refId]);

    return (
        <Spin spinning={loading}>
            {jsonData && (
                <div ref={ref}>
                    <PreviewForm
                        refId={refId}
                        style={style}
                        part={jsonData}
                        dataBreachFormId={dsBreachDetail?.dataBreachFormId}
                    />
                </div>
            )}
        </Spin>
    );
}
